import $ from "jquery";
import Mustache from 'mustache';
import bootbox from 'bootbox';
import {getCookie} from "./gppy-misc";
import GPPYShareByEmail from "./gppy-share-by-email.svelte";
import GPPYShareByLink from "./gppy-share-by-link.svelte";

var GPPYProject = {

    init: function() {
        $('.toggleProjectFavourite').click(GPPYProject.toggleProjectVote);
        $('.toggleProjectPrivate').click(GPPYProject.toggleProjectPrivate);
        $('.deleteProject').click(GPPYProject.deleteProject);
        $('.shareOnFB').click(GPPYProject.shareOnFB);

        let rel = document.querySelector('.projectRename');
        if (rel)
            rel.addEventListener('click', GPPYProject.renameMode);

        let el = document.querySelector(".projectRenameElement");
        if (el)
            el.addEventListener("keydown", (e) => {
                if (e.code === "NumpadEnter" || e.code === "Enter") {
                    e.preventDefault();
                    GPPYProject.doRename();
                }
            })

        GPPYProject.checkItemsLimit();

        $('.shareByEmail').click(() => {
            let component = new GPPYShareByEmail({
                target: document.body,
                props: {}
            });
            component.showForm();
        });

        $('.shareByLink').click(() => {
            let component = new GPPYShareByLink({
                target: document.body,
                props: {}
            });
            component.showForm();
        });
    },

    toggleProjectVote: function() {
        var project_id = $('[project_id]').eq(0).attr('project_id');
        var data = {project_id: project_id};
        Promise.resolve($.post('/api/toggleprojectvote',data)).
            then(GPPYProject.updateProjectVote);
    },

    updateProjectVote: function(res) {
        if (res.isfavourite)
            $('.projectpage').removeClass('projectnotfavourite').addClass('projectfavourite');
        else
            $('.projectpage').removeClass('projectfavourite').addClass('projectnotfavourite');
    },

    toggleProjectPrivate: function() {
        var project_id = $('[project_id]').eq(0).attr('project_id');
        var data = {project_id: project_id};
        Promise.resolve($.post('/api/toggleprojectprivate',data)).
            then(GPPYProject.updateProjectPrivate);
    },

    updateProjectPrivate: function(res) {
        if (res.isprivate)
            $('.projectpage').removeClass('projectpublic').addClass('projectprivate');
        else
            $('.projectpage').removeClass('projectprivate').addClass('projectpublic');
    },

    deleteProject: function() {
        var project_id = $('[project_id]').eq(0).attr('project_id');
        var data = {project_id: project_id};
        bootbox.confirm({
            message: gettext("This cannot be undone, are you sure?"),
            buttons: {
                confirm: {
                    label: gettext('OK')
                },
                cancel: {
                    label: gettext('Cancel')
                }
            },
            callback: function(res) {
                    if (res) Promise.resolve($.post('/api/deleteProject',data)).
                        then(function() {window.location = "/users/profile"});
                }
        });
    },

    checkItemsLimit: function() {
        if ($('.gppy-project-items li img').length > 9) {
            $('.gppy-project-items ul li').eq(8).after('<li class="gppy-project-items-more"><div class="itempane"><a>'+gettext('View all')+'</a></div></li>');
            $('.gppy-project-items-more').off().on('click', GPPYProject.showAllItems);
        }
    },

    showAllItems: function() {
        $('.gppy-project-items').removeClass('gppy-project-items-limited');
        $('.gppy-project-items-more').remove();
    },

    shareOnFB: function() {
        var project_id = $('[project_id]').eq(0).attr('project_id');
        var url = window.location.href;
        var title = $("meta[property=og\\:title]").attr("content") || document.title;

        window.open(
          "https://www.facebook.com/sharer/sharer.php?u="+url+"&title="+title,
          'facebook-share-dialog',
          'width=626,height=436');
        return false;

    },

    renameMode: function(e) {
        let elClicked = e.target;
        let el = elClicked.previousElementSibling;
        const selection = window.getSelection();
        const range = document.createRange();
        selection.removeAllRanges();
        range.selectNodeContents(el);
        range.collapse(false);
        selection.addRange(range);
        el.focus();
    },

    doRename() {
        const el = document.querySelector(".projectRenameElement");
        let new_name = el.textContent;
        let params = 'project_id=' + $('[project_id]').eq(0).attr('project_id') + '&new_name='+new_name;
        fetch('/api/renameProject', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json',
              'X-CSRFToken': getCookie('csrftoken')
            },
            body: params
        }).then(res => res.json()).then((res) => {
            if (res.result === "OK")
                document.activeElement.blur();
            else alert("Problem with renaming")
        }).catch(() => {
            alert("Problem with renaming")
        })
    }

}

$('document').ready(GPPYProject.init);


